import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import pages from "../../constants/pages";
import Table from "./list components/Table";
import { useComponent } from "../../hooks";
import { PageHeader, Loader } from "../../components";

export default function Actions({ pageID }) {
  const { activeBot } = useSelector((state) => state.memberDetails);
  const { axios, loader, pagePermissions } = useComponent({ pageID });

  const [actions, setActions] = useState([]);

  useEffect(() => {
    loader.start();

    axios({
      url: `/workflow/action/${activeBot.ID}`,
    }).then((response) => {
      if (response.status) {
        loader.apiComplete();

        setActions(response.data);
      }
    });
  }, [activeBot.ID, axios, loader]);

  return (
    <Loader>
      <PageHeader
        pageName="Action"
        addIcon={[
          "Add New Action",
          pages.actionCreatePage.route,
          pagePermissions.create,
        ]}
      />

      <Table actions={actions} />
    </Loader>
  );
}
